import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Hotels = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddHotel = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditHotel = () => {
  return (
    
      
        <Edit />
      
    
  );
};
